import { render, staticRenderFns } from "./CameraScanOverlay.vue?vue&type=template&id=f50e1986&scoped=true"
var script = {}
import style0 from "./CameraScanOverlay.vue?vue&type=style&index=0&id=f50e1986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50e1986",
  null
  
)

export default component.exports